import React, { useState } from 'react';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import Typography from '../../Typography';
import { useTranslation } from 'react-i18next';
import { Faqs, FaqsList, Faq, Question, Subtitle, Answer} from '../index.styled'

const FaqButton = styled.div`
  font-family: 'ToyotaType Bold';
  font-size: 13px;
	line-height: 32px;
	letter-spacing: 0.05em;
  display: ${({expanded}) => expanded ? 'none' : 'flex'};
  justify-content: space-between;
  width: 90%;
  & > div {
    font-family: 'ToyotaType Book';
    font-size: 20px;
  }
  
`
const ButtonWrapper = styled.div`
  display: ${({expanded})=> expanded ? 'none' : 'flex'};
  justify-content: center;
  height: 35px;
  width: 90%;
  border-bottom: 1px solid black;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`
const Close = styled.button`
  border: none;
  background: none;
  font-family: 'ToyotaType Book';
`

const FaqHeading = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
`

export const FaqCollapsed = ({faqs}) => {
  const [expanded, setExpanded] = useState(false)
  const { t } = useTranslation();
  return (
    <Wrapper>
      <ButtonWrapper expanded={expanded}>
        <FaqButton  expanded={expanded} onClick={()=>setExpanded(!expanded)}>
          <span>{t('PortfolioDetailModal.sections.faq.heading')}</span>
          <div>&#43;</div>
        </FaqButton>
      </ButtonWrapper>
      {
        expanded && (
          <Fade>
            <Faqs expanded={expanded}>
              <FaqHeading>
                <Typography.BodyBold>{t('PortfolioDetailModal.sections.faq.heading')}</Typography.BodyBold>
                <Close onClick={()=>setExpanded(!expanded)}>
                  &#10005;
                </Close>
              </FaqHeading>
              <FaqsList>
                {faqs.map(faq => (
                    <Faq key={faq[0]}>
                      <Question>
                        <Subtitle>{faq[0]}</Subtitle>
                      </Question>
                      <Answer>
                        <Typography.BodySmall>{faq[1]}</Typography.BodySmall>
                      </Answer>
                    </Faq>
                  )
                )}
              </FaqsList>
            </Faqs>
          </Fade>
        )
      }
    </Wrapper>
  )
}